// contexts/MenuProvider.jsx
import React, { useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { MenuContext } from './MenuContext';

export const MenuProvider = ({ children }) => {
  const [openMenus, setOpenMenus] = useState({});
  const location = useLocation();
  const [prevPathname, setPrevPathname] = useState(location.pathname);

  // Ajustement de l'état pendant le rendu (pattern recommandé par React
  // pour "reset state when a prop changes"), plutôt que dans un effet,
  // afin d'éviter un rendu en cascade. On utilise un état (et non une ref)
  // car la lecture de ref.current pendant le rendu n'est pas autorisée.
  if (prevPathname !== location.pathname) {
    setPrevPathname(location.pathname);
    setOpenMenus({});
  }

  
  const toggleMenu = useCallback((menuLabel) => {
    setOpenMenus(prev => ({
      ...prev,
      [menuLabel]: !prev[menuLabel]
    }));
  }, []);

  const closeAllMenus = useCallback(() => {
    setOpenMenus({});
  }, []);

  const closeMenu = useCallback((menuLabel) => {
    setOpenMenus(prev => ({
      ...prev,
      [menuLabel]: false
    }));
  }, []);

  const openMenu = useCallback((menuLabel) => {
    setOpenMenus(prev => ({
      ...prev,
      [menuLabel]: true
    }));
  }, []);

  const value = {
    openMenus,
    toggleMenu,
    closeAllMenus,
    closeMenu,
    openMenu
  };

  return (
    <MenuContext.Provider value={value}>
      {children}
    </MenuContext.Provider>
  );
};